import store from "@/state/store";
import isMenu from "@/middleware/is-menu";

export default [
  {
    path: "/",
    redirect: "/portal",
    component: () => import("../views/portal/index"),
    children: [
      // Components
      {
        name: "Landing Page",
        path: "/portal",
        component: () => import("../views/portal/index"),
        meta: {
          title: "Landing Page",
          authRequired: false,
        },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "Dashboard" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/edit-profile",
    name: "edit-profile",
    meta: {
      title: "Ubah Password",
      authRequired: true,
    },
    component: () => import("../views/account/edit-profile.vue"),
  },
  {
    path: "/customer-support",
    name: "customer-support",
    meta: {
      title: "Customer Support",
      authRequired: true,
    },
    component: () => import("../views/account/customer-support.vue"),
  },
  {
    path: "/feedback",
    name: "feedback",
    meta: {
      title: "Feedback",
      authRequired: true,
    },
    component: () => import("../views/account/feedback.vue"),
  },
  {
    path: "/carbon-footprint/dashboard",
    name: "dashboard-carbon",
    meta: {
      title: "Dashboard Carbon",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import("../views/monitoring-carbon/carbon-footprint/dashboard/index.vue"),
  },
  {
    path: "/carbon-footprint/scope1/stationary-combustion",
    name: "scope1-stationary-combustion",
    meta: {
      title: "Scope 1 - Stationary Combustion",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/scope1/stationary-combustion/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/scope1/mobile-combustion",
    name: "scope1-mobile-combustion",
    meta: {
      title: "Scope 1 - Mobile Combustion",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/scope1/mobile-combustion/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/scope1/refrigerant",
    name: "scope1-refrigerant",
    meta: {
      title: "Scope 1 - Refrigerant",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/scope1/refrigerant/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/scope2/purchased-energy",
    name: "scope2-refrigerant",
    meta: {
      title: "Scope 2 - Purchased Energy",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/scope2/purchased-energy/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/scope3/category1n2",
    name: "scope3-category1n2",
    meta: {
      title: "Scope 3 - Category 1 and 2",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/scope3/category1n2/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/company-setup/company-information",
    name: "scope2-refrigexrant",
    meta: {
      title: "Scope 2 - Purchased Energy",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/company-setup/company-information/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/company-setup/operational-facility",
    name: "scope2-refrigeraznt",
    meta: {
      title: "Scope 2 - Purchased Energy",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/company-setup/operational-facility/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/company-setup/scope-setup",
    name: "scope2-refrigesrant",
    meta: {
      title: "Scope 2 - Purchased Energy",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/company-setup/scope-setup/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/master/category",
    name: "master-category",
    meta: {
      title: "Master - Category",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/master/category/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/master/sub-category",
    name: "master-sub-category",
    meta: {
      title: "Master - Sub Category",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/master/sub-category/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/master/unit",
    name: "master-unit",
    meta: {
      title: "Master - Unit",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/master/unit/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/master/factor",
    name: "master-factor",
    meta: {
      title: "Master - Factor",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/master/factor/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/master/company-sector",
    name: "master-company-sector",
    meta: {
      title: "Master - Company Sector",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/master/company-sector/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/master/scope",
    name: "master-scope",
    meta: {
      title: "Master - Scope",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/master/scope/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/master/scope-type",
    name: "master-scope-type",
    meta: {
      title: "Master - Scope Type",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/master/scope-type/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/master/refrigerant-application",
    name: "master-refrigerant-application",
    meta: {
      title: "Master - Refrigerant Application",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/master/refrigerant-application/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/master/currency",
    name: "master-currency",
    meta: {
      title: "Master - Currency",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/master/currency/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/master/procurement-type",
    name: "master-procurement-type",
    meta: {
      title: "Master - Procurement Type",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/master/procurement-type/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/master/factory-type",
    name: "master-factory-type",
    meta: {
      title: "Master - Factory Type",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/master/factory-type/index.vue"
      ),
  },
  {
    path: "/carbon-footprint/master/refrigerant-application",
    name: "master-refrigerant-application",
    meta: {
      title: "Master - Refrigerant Application",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-footprint/master/refrigerant-application/index.vue"
      ),
  },
  {
    path: "/carbon-offset",
    name: "carbon-offset",
    meta: {
      title: "Carbon Offset New",
      authRequired: true,
    },
    component: () =>
      import("../views/monitoring-carbon/carbon-offset-new/index.vue"),
  },
  {
    path: "/carbon-offset/maintenance",
    name: "carbon-offset-maintenance",
    meta: {
      title: "Maintenance",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/carbon-offset",
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-offset-new/maintenance/index.vue"
      ),
  },

  {
    path: "/carbon-offset-old",
    name: "carbon-offset-old",
    meta: {
      title: "Carbon Offset",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import("../views/monitoring-carbon/carbon-offset/index.vue"),
  },
  {
    path: "/carbon-offset/simulasi-offset/:companyId/:facilityId",
    name: "simulasi-offset",
    meta: {
      title: "Simulasi Offset Now",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/carbon-offset",
    },
    component: () =>
      import(
        "../views/monitoring-carbon/carbon-offset/simulasi-offset/index.vue"
      ),
  },
  {
    path: "/carbon-offset/order-offset",
    name: "order-offset",
    meta: {
      title: "Offset Now",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/carbon-offset",
    },
    component: () =>
      import("../views/monitoring-carbon/carbon-offset/order-offset/index.vue"),
  },
  {
    path: "/carbon-offset/simulasi-ev",
    name: "simulasi-ev",
    meta: {
      title: "Simulasi EV Now",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/carbon-offset",
    },
    component: () =>
      import("../views/monitoring-carbon/carbon-offset/simulasi-ev/index.vue"),
  },
  {
    path: "/carbon-offset/order-ev",
    name: "order-ev",
    meta: {
      title: "Order EV Now",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/carbon-offset",
    },
    component: () =>
      import("../views/monitoring-carbon/carbon-offset/order-ev/index.vue"),
  },
  {
    path: "/carbon-offset/simulasi-pv/:companyId/:facilityId",
    name: "simulasi-pv",
    meta: {
      title: "Simulasi PV Now",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/carbon-offset",
    },
    component: () =>
      import("../views/monitoring-carbon/carbon-offset/simulasi-pv/index.vue"),
  },
  {
    path: "/carbon-offset/order-pv",
    name: "order-pv",
    meta: {
      title: "Order PV Now",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/carbon-offset",
    },
    component: () =>
      import("../views/monitoring-carbon/carbon-offset/order-pv/index.vue"),
  },
  {
    path: "/settings/status-pelanggan",
    name: "pelanggan",
    meta: {
      title: "Settings - ID Pelanggan",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/settings/idPel/index.vue"),
  },
  {
    path: "/settings/status-pelanggan",
    name: "pelanggan-detail",
    meta: {
      title: "Detail ID Pelanggan",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/settings/idPel/detail/index.vue"),
  },
  {
    path: "/settings/role",
    name: "role",
    meta: {
      title: "Settings - Role",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/settings/role/index.vue"),
  },
  {
    path: "/settings/menu",
    name: "menu",
    meta: {
      title: "Settings - Menu",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/settings/menu/index.vue"),
  },
  {
    path: "/settings/rlmenu",
    name: "role-menu",
    meta: {
      title: "Settings - Role Menu",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/settings/role-menu/index.vue"),
  },
  {
    path: "/settings/user",
    name: "user",
    meta: {
      title: "Settings - User",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/settings/user/index.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    meta: {
      title: "Dashboard",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/dashboard/home/index"),
  },
  {
    path: "/electricity/monitoring",
    name: "monitoring",
    meta: { title: "Monitoring", authRequired: true, middleware: [isMenu] },
    component: () => import("../views/electricity/monitoring/index"),
  },
  {
    path: "/electricity/monitoring",
    name: "monitoring-detail",
    meta: {
      title: "Detail Monitoring",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/electricity/monitoring/detail/index"),
  },
  {
    path: "/electricity/analytic",
    name: "analytic",
    meta: { title: "Analytic", authRequired: true, middleware: [isMenu] },
    component: () => import("../views/electricity/analytic/index"),
  },
  {
    path: "/electricity/billing",
    name: "billing",
    meta: { title: "Billing", authRequired: true, middleware: [isMenu] },
    component: () => import("../views/electricity/billing/index"),
  },
  {
    path: "/electricity/billing/history",
    name: "billing-history",
    meta: {
      title: "History Billing",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/electricity/billing",
    },
    component: () => import("../views/electricity/billing/history"),
  },
  // {
  //   path: "/test",
  //   name: "test",
  //   component: () => import("../views/electricity/billing/InvoiceNew.vue"),
  //   meta: {
  //     title: "test",
  //     beforeResolve(routeTo, routeFrom, next) {
  //         next();
  //       }
  //   },
  // },
  {
    path: "/electricity/outage",
    name: "outage",
    meta: {
      title: "Power Outage",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/electricity/power-outage/index"),
  },
  {
    path: "/electricity/jarvis-analytic",
    name: "Analytic Jarvis",
    meta: {
      title: "Analytic Jarvis",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/electricity/analytic-jarvis/index"),
  },
  {
    path: "/collective-payment/bundling-payment",
    name: "collective-payment",
    meta: {
      title: "Collective Payment",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/collective-payment/index"),
  },
  {
    path: "/collective-payment/bundling-payment/detail",
    name: "collective-payment-detail-group",
    meta: {
      title: "Collective Payment Detail Grup",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/collective-payment/bundling-payment",
    },
    component: () =>
      import("../views/collective-payment/detail-group-kolektif/index"),
  },
  {
    path: "/collective-payment/bundling-payment/tagihan",
    name: "collective-payment-detail-tagihan",
    meta: {
      title: "Collective Payment Detail Tagihan",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/collective-payment/bundling-payment",
    },
    component: () =>
      import("../views/collective-payment/inquiry-group/index"),
  },
  {
    path: "/collective-payment/history-topup",
    name: "collective-payment-history-topup",
    meta: {
      title: "History Topup",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/collective-payment",
    },
    component: () => import("../views/collective-payment/riwayat-topup/index"),
  },
  {
    path: "/collective-payment/history-payment",
    name: "collective-payment-history-payment",
    meta: {
      title: "History Payment",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import("../views/collective-payment/riwayat-pembayaran/index"),
  },
  {
    path: "/collective-payment/progress-payment",
    name: "collective-payment-progress-payment",
    meta: {
      title: "History Payment",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/collective-payment",
    },
    component: () =>
      import("../views/collective-payment/progress-pembayaran/index"),
  },
  {
    path: "/collective-payment/topup",
    name: "collective-payment-topup",
    meta: {
      title: "Topup",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/collective-payment",
    },
    component: () => import("../views/collective-payment/topup/inputTopup"),
  },
  {
    path: "/collective-payment/payment/:id",
    name: "collective-payment-payment",
    meta: {
      title: "Payment",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/collective-payment",
    },
    component: () => import("../views/collective-payment/topup/payment"),
  },
  {
    path: "/collective-payment/payment-confirmation/:id",
    name: "collective-payment-confirmation-payment",
    meta: {
      title: "Payment",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/collective-payment",
    },
    component: () => import("../views/collective-payment/topup/confirmPayment"),
  },
  {
    path: "/collective-payment/summary-payment",
    name: "collective-payment-summary-payment",
    meta: {
      title: "Summary Payment",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/collective-payment/bundling-payment",
    },
    component: () =>
      import("../views/collective-payment/summary/summaryPayment"),
  },
  {
    path: "/collective-payment/summary-saldo",
    name: "collective-payment-summary-saldo",
    meta: {
      title: "Summary Saldo",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/collective-payment",
    },
    component: () =>
      import("../views/collective-payment/summary/summaryPayment"),
  },
  {
    path: "/collective-payment/finish-payment",
    name: "collective-payment-finish-payment",
    meta: {
      title: "Summary Payment",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/collective-payment/bundling-payment",
    },
    component: () =>
      import("../views/collective-payment/summary/finishPayment"),
  },

  {
    path: "/collective-payment/payment-history",
    name: "collective-payment-history",
    meta: {
      title: "Payment History",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () =>
      import("../views/collective-payment/payment-history/index"),
  },
  {
    path: "/collective-payment/payment-history/detail",
    name: "collective-payment-history-detail",
    meta: {
      title: "Detail Payment",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/collective-payment/payment-history",
    },
    component: () =>
      import("../views/collective-payment/detail-payment-history/index"),
  },
  {
    path: "/collective-payment/settings-admin-fee",
    name: "collective-payment-settings-admin-fee",
    meta: {
      title: "Payment",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/collective-payment",
    },
    component: () =>
      import("../views/collective-payment/settings-admin-fee/index"),
  },
  {
    path: "/collective-payment/download-pdf/",
    name: "download-pdf",
    meta: {
      title: "Download PDF",
      // middleware: [isMenu],
      authRequired: true,
      parentPath: "/collective-payment",
    },
    component: () => import("../views/collective-payment/coba.vue"),
  },
  {
    path: "/collective-payment/invoice/:id",
    name: "invoice-payment",
    meta: {
      title: "Invoice Payment",
      // middleware: [isMenu],
      // authRequired: true,
      parentPath: "/collective-payment",
    },
    component: () => import("../views/collective-payment/summary/invoice.vue"),
  },
  {
    path: "/power-outage/detail-pemeliharaan",
    name: "power-outage-detail-pemeliharaan",
    meta: {
      title: "Detail Pemeliharaan",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/electricity/outage",
    },
    component: () =>
      import("../views/electricity/power-outage/detail/maintenance"),
  },
  {
    path: "/power-outage/detail-system",
    name: "power-outage-detail-system",
    meta: {
      title: "Detail System",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/electricity/outage",
    },
    component: () => import("../views/electricity/power-outage/detail/system"),
  },
  {
    path: "/power-outage/detail-individu",
    name: "power-outage-detail-individu",
    meta: {
      title: "Detail Individu",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/electricity/outage",
    },
    component: () =>
      import("../views/electricity/power-outage/detail/individu"),
  },
  {
    path: "/power-outage/detail-komplain",
    name: "power-outage-detail-komplain",
    meta: {
      title: "Detail Komplain",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/electricity/outage",
    },
    component: () =>
      import("../views/electricity/power-outage/detail/complaint"),
  },
  {
    path: "/power-outage/trend-gangguan",
    name: "power-outage-trend-gangguan",
    meta: {
      title: "Detail Trend Gangguan",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/electricity/outage",
    },
    component: () =>
      import("../views/electricity/power-outage/detail/trensGangguan"),
  },
  {
    path: "/management/tenant",
    name: "management-tenant",
    meta: {
      title: "Tenant",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-tenant/company/index"),
  },
  {
    path: "/management/tenant/regional",
    name: "management-tenant-regional",
    meta: {
      title: "Regional",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/management/tenant",
    },
    component: () => import("../views/management-tenant/regional/index"),
  },
  {
    path: "/management/tenant/site",
    name: "management-tenant-site",
    meta: {
      title: "Site",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/management/tenant",
    },
    component: () => import("../views/management-tenant/site-area/index"),
  },
  {
    path: "/management/tenant/customer",
    name: "management-tenant-customer",
    meta: {
      title: "Customer",
      authRequired: true,
      middleware: [isMenu],
      parentPath: "/management/tenant",
    },
    component: () => import("../views/management-tenant/customer/index"),
  },
  {
    path: "/management/data-sync",
    name: "management-data-sync",
    meta: {
      title: "Data Sync",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-tenant/data-sync/index"),
  },
  {
    path: "/management/check-amr",
    name: "management-check-amr",
    meta: {
      title: "Check Id Customer",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-tenant/check-amr/index"),
  },
  {
    path: "/management/monitoring-amr",
    name: "monitoring-amr",
    meta: {
      title: "Monitoring AMR",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-tenant/monitoring-amr/index"),
  },
  {
    path: "/management/monitoring-amr/area",
    name: "monitoring-amr-area",
    parent: "/monitoring-amr",
    meta: {
      title: "Monitoring AMR",
      authRequired: true,
    },
    component: () =>
      import("../views/management-tenant/monitoring-amr/detail.vue"),
  },
  {
    path: "/management/monitoring-amr/transaksi",
    name: "monitoring-amr-transaksi",
    parent: "/monitoring-amr",
    meta: {
      title: "Monitoring AMR",
      authRequired: true,
    },
    component: () =>
      import("../views/management-tenant/monitoring-amr/detail-transaksi.vue"),
  },
  {
    path: "/management/complaint",
    name: "monitoring-complaint",
    meta: {
      title: "Monitoring Complaint",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-tenant/complaint/index"),
  },
  {
    path: "/management/feedback",
    name: "monitoring-feedback",
    meta: {
      title: "Monitoring Feedback",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-tenant/feedback/index"),
  },
  {
    path: "/management/ev",
    name: "management-ev",
    meta: {
      title: "Management EV ",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-tenant/ev/index"),
  },
  {
    path: "/management/pv",
    name: "management-pv",
    meta: {
      title: "Management PV ",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-tenant/pv/index"),
  },
  {
    path: "/management-portal/article",
    name: "management-article",
    meta: {
      title: "Management Article",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-portal/article/index"),
  },
  {
    path: "/management-portal/client",
    name: "management-client",
    meta: {
      title: "Management Client",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-portal/client/index"),
  },
  {
    path: "/management-portal/video",
    name: "management-video",
    meta: {
      title: "Management Video",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-portal/video/index"),
  },
  {
    path: "/management-portal/feature",
    name: "management-feature",
    meta: {
      title: "Management Feature",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-portal/feature/index"),
  },
  {
    path: "/management-portal/faq",
    name: "management-faq",
    meta: {
      title: "Management FAQ",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-portal/faq/index"),
  },
  {
    path: "/management-portal/company-profile",
    name: "management-company-profile",
    meta: {
      title: "Management Company Profile",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/management-portal/company-profile/index"),
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: true,
      middleware: [isMenu],
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("../views/auth/logout/basic"),
  },

  {
    path: "/auth/404-basic",
    name: "404-basic",
    meta: {
      title: "Error 404",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/auth/errors/404-basic"),
  },
  {
    path: "/auth/404-cover",
    name: "404-cover",
    meta: {
      title: "Error 404",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/auth/errors/404-cover"),
  },

  // ---------------------------------- portal ----------------------------------

  {
    path: "/portal/contact-us/",
    name: "Contact Us",
    meta: { title: "Contact Us", authRequired: false },
    component: () => import("../views/portal/interestForm"),
  },
  {
    path: "/portal/article/",
    name: "All Article",
    meta: { title: "All Article", authRequired: false },
    component: () => import("../views/portal/article/index"),
  },
  {
    path: "/portal/article/:id",
    name: "Detail Article",
    meta: { title: "Detail Article", authRequired: false },
    component: () => import("../views/portal/article/show"),
  },
  // ---------------------------------- end portal section ----------------------------------

  {
    path: "/:pathMatch(.*)*",
    name: "PageNotFound",
    meta: { title: "Page Not Found", authRequired: false },
    component: () => import("../views/pagenotfound"),
  },
  // ---------------------------------- Start PV Rooftop ----------------------------------
  {
    path: "/pv-rooftop/dashboard",
    name: "pv-dashboard",
    meta: { title: "Dashboard", authRequired: true },
    component: () => import("../views/pv-rooftop/dashboard/index"),
  },
  {
    path: "/pv-rooftop/dashboard/detail",
    name: "pv-dashboard-detail",
    parent: "/pv-rooftop/dashboard",
    meta: { title: "Detail Plant", authRequired: true },
    component: () => import("../views/pv-rooftop/dashboard/detail/index"),
  },
  {
    path: "/pv-rooftop/monitoring",
    name: "pv-monitoring",
    meta: { title: "Monitoring", authRequired: true, middleware: [isMenu] },
    component: () => import("../views/pv-rooftop/monitoring/index"),
  },
  {
    path: "/pv-rooftop/monitoring",
    name: "pv-monitoring-detail",
    meta: {
      title: "Detail PV Monitoring",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/pv-rooftop/monitoring/detail/index"),
  },
  // ---------------------------------- Start EV Monitoring ----------------------------------
  {
    path: "/electric-vehicle/",
    name: "electric-vehicle",
    meta: {
      title: "Electric Vehicle",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/electric-vehicle/index"),
  },
  {
    path: "/electric-vehicle/carbon",
    name: "electric-vehicle-carbon",
    meta: {
      title: "Electric Vehicle - Carbon EV",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/electric-vehicle/carbon/index"),
  },
  {
    path: "/electric-vehicle/master-vehicle",
    name: "electric-vehicle-master-vehicle",
    meta: {
      title: "Electric Vehicle - Data Vehicle",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/electric-vehicle/master/vehicle/index"),
  },
  {
    path: "/electric-vehicle/monitoring",
    name: "electric-vehicle-monitoring",
    meta: {
      title: "Electric Vehicle - Monitoring Vehicle",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/electric-vehicle/monitoring/index"),
  },

  {
    path: "/electric-vehicle/rekapitulasi",
    name: "electric-vehicle-rekapitulasi",
    meta: {
      title: "Electric Vehicle - Rekapitulasi Perjalanan",
      authRequired: true,
      // middleware: [isMenu],
    },
    component: () => import("../views/electric-vehicle/rekapitulasi/index"),
  },
  {
    path: "/electric-vehicle/master-vehicle/add",
    name: "electric-vehicle-add",
    meta: {
      title: "Electric Vehicle - Add Vehicle",
      authRequired: true,
    },
    component: () =>
      import("../views/electric-vehicle/master/vehicle/addVehicle.vue"),
  },
  {
    path: "/electric-vehicle/master-vehicle/compare",
    name: "electric-vehicle-compare",
    meta: {
      title: "Electric Vehicle - Compare Vehicle",
      authRequired: true,
    },
    component: () =>
      import("../views/electric-vehicle/master/vehicle/beforeVehicle.vue"),
  },
  {
    path: "/electric-vehicle/master-vehicle/detail",
    name: "electric-vehicle-detail",
    meta: {
      title: "Electric Vehicle - Detail Vehicle",
      authRequired: true,
    },
    component: () =>
      import("../views/electric-vehicle/master/vehicle/detailVehicle.vue"),
  },
  {
    path: "/monitoring-iot/ac",
    name: "monitoring-iot-ac",
    meta: {
      title: "monitoring-iot-ac",
      authRequired: true,
      middleware: [isMenu],
    },
    component: () => import("../views/monitoring-iot/monitoring-ac/index.vue"),
  },
  {
    path: "/monitoring-iot/ac/detail",
    name: "monitoring-iot-ac-detail",
    parent: "/monitoring-iot/ac",
    meta: {
      title: "Monitoring IoT - Detail Monitoring AC",
      authRequired: true,
    },
    component: () =>
      import("../views/monitoring-iot/monitoring-ac/detail/index.vue"),
  },
  {
    path: "/monitoring-iot/ac/detail-ac",
    name: "monitoring-iot-detail-ac",
    parent: "/monitoring-iot/ac",
    meta: {
      title: "Monitoring IoT - Detail Monitoring AC Per ID Pelanggan",
      authRequired: true,
    },
    component: () =>
      import("../views/monitoring-iot/monitoring-ac/detail-ac/index.vue"),
  },
];